"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.FRAMEWORK=exports.PLATFORM=exports.RUNTIME=void 0,exports.RUNTIME={WEB:"Web",WEEX:"Weex",UNKNOWN:"Unknown"},exports.PLATFORM={MAC:"Mac",WINDOWS:"Windows",IOS:"iOS",ANDROID:"Android",IPAD:"iPad",BROWSER:"Browser",UNKNOWN:"Unknown"},exports.FRAMEWORK={VUE:"Vue",RAX:"Rax",UNKNOWN:"Unknown"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_dingtalk-jsapi@2.13.50@dingtalk-jsapi/lib/packages/dingtalk-javascript-env/constants.js
// module id = +6bv
// module chunks = 0